"use strict";

require("xp-lib-brand/react/index");